export default function (state, val) {
    let data = [];
    let items = val.items;
    items.forEach(i => {
        let item = data.filter(j => {
            return j.currency === i.CurrencyId;
        })[0];
        if (!item) {
            data.push({
                currency: i.CurrencyId,


                isPayed: 0,         //Оплаченные


                available: 0,    //Доступно для оплаты
                isActive: 0,    //Активных
                incomes: 0,    //Прибыль
                amount: 0,    //Количество
                payed: 0,    //Оплачено
                debt: 0,    //Задолженность
                sum: 0,    //Сумма

            });
            item = data.filter(j => {
                return j.currency === i.CurrencyId;
            })[0];
        }
        item.amount++;
        item.sum += i.Sum;
        item.available += i.AvailableSum;
        item.incomes += (i.IsPayed&&i.IsUsed) ?(i.NotUsedSum - i.AvailableSum):0;
        item.debt += i.IsPayed ? 0 : i.Sum;
        item.payed += i.IsPayed ? i.Sum : 0;
        item.isPayed += (i.IsPayed && i.PaymentId) ? 1 : 0;
        item.isActive += (i.IsPayed && !i.IsUsed) ? 1 : 0;

    });
    state.items = data;
}